import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=65de74ee&"
import script from "./Recognition.vue?vue&type=script&lang=ts&"
export * from "./Recognition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports